<template>
    <div>
        <h2>ช่องทางการจัดส่ง > ตั้งค่า SHIP POP</h2>
        <v-form v-model="isFormValid">
          <v-card class="mt-4">
            <div class="pa-8">
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="formData.shippop_api"
                    outlined
                    label="API KEY *"                               
                    :rules="[validators.required]"
                    hide-details="auto"          
                    dense  
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="formData.shippop_email"
                    outlined
                    label="Email *"                               
                    :rules="[validators.required]"
                    hide-details="auto"          
                    dense  
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>

            <v-card-actions>              
              <v-btn
                color="primary"               
                large          
                :disabled="!isFormValid"
                :loading="sendingData"
                @click="submitForm"
                v-if="$store.getters['app/GET_APP_MODE'] != 'read'"
              >
                {{ $store.getters['app/GET_APP_MODE'] == 'create' ? "สร้าง" : "แก้ไข"}}
              </v-btn>

              <v-btn
                color="secondary"               
                outlined                 
                large
                :disabled="sendingData"
                @click="$router.go(-1)"
              >
                กลับ
              </v-btn>                
            </v-card-actions>
          </v-card>          
        </v-form>
    </div>
</template>
<script>
import { required } from '@/@core/utils/validation'
import { asyncGet, asyncUpdate } from '@/helpers/asyncAxios'
export default {
  data() {
    return {
      isFormValid: false,
      sendingData: false,
      deliveryProvider: [],
      validators: {
        required,
      },
      courierList: [],
      formData: {
        shippop_api: '',
        shippop_email: '',
      },
    }
  },
  async created() {
    this.$store.commit('app/SET_GLOBAL_LOADING', true)

    this.$store.commit('app/SET_APP_MODE', 'edit')

    const { shippop_api, shippop_email } = await asyncGet('/setting/delivery/shippop')

    this.formData.shippop_api = shippop_api
    this.formData.shippop_email = shippop_email

    this.$store.commit('app/SET_GLOBAL_LOADING', false)
  },
  methods: {
    async submitForm() {
      this.sendingData = true
      try {
        await asyncUpdate('/setting/delivery/shippop', this.formData)

        this.$router.push({ name: 'delivery' })
      } catch (error) {
        this.$root.showCommonDialog('มีปัญหา', error)
      }

      this.sendingData = false
    },
  },
  components: {},
}
</script>